module.exports = new __parcel__URL__("smokescreen.424742cd.png").toString();